import { getWetterstation } from './functions/getWetterstation';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { DataService } from '../../services/data_service';
import { ApiService } from '../../services/api_service';
import { validateFieldUniversal } from './functions/validateField';
import { WFormData } from '../../core/forms/WFormData';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { getCustomFormConfig } from './co2_custom/getCustomFormConfig';
import { FormBtnTochtergesellschaften } from './dialogs/FormBtnTochtergesellschaften';
import { hasFeature } from '../../control/hasFeature';
import { Features } from '../../control/features';

interface DateneingabeBetrieblicheDatenStandortProps {
    data: any;
    standortSelected: any;
}

interface DateneingabeBetrieblicheDatenStandortPropsState {
    showDialog: string;
    refreshStamp: number;
    bundleFilterFunc: (bundle: any) => void;
}

export class DateneingabeBetrieblicheDatenStandort extends
    React.Component<DateneingabeBetrieblicheDatenStandortProps, DateneingabeBetrieblicheDatenStandortPropsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: null,
            refreshStamp: 0,
            bundleFilterFunc: (bundle: any) => {
                bundle.standort_typ_tid = bundle.standort_typ_tid.filter((item: any) => !(+item.tid === 5 || +item.tid === 6));
                return bundle;
            },
        };

        this.onFormChangeInteractive = this.onFormChangeInteractive.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.validateField = this.validateField.bind(this);
        this.getTochtergesellschaftenBtn = this.getTochtergesellschaftenBtn.bind(this);

        this.showGruppen = hasFeature(Features.STANDORT_GRUPPEN, this.apiService.getBereichKey());
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(ApiService) private apiService: ApiService;

    private lastAdressString: string;
    private showGruppen: boolean = false;

    onFormChange(WFormData: any): void {
        onFormChangeUniversal(IDs.ENT_STANDORT, WFormData, this, this.props.data);
        // Wir triggern das Update-Event um die lokalen Daten sofort zu ändern, ohne zu warten.
        // Natürlich kommen später noch der Datensatz aus dem Server.
        const update: any = {
            [IDs.ENT_STANDORT]: {
                tid: WFormData.getValue('tid'),
                name: WFormData.getValue('name'),
                plz: WFormData.getValue('plz')
            }
        };
        this.triggerService.fire('updateLocalDataByEntity', 'dataObject', update);
    }

    async onFormChangeInteractive(formData: WFormData, onValueChange: (name: string, value: any) => void): Promise<void> {
        this.lastAdressString = await getWetterstation(this.props.data, this.lastAdressString, formData, onValueChange);
    }

    render(): JSX.Element {
        const standort: any = (this.props.data[IDs.ENT_STANDORT] || []).find((s: any) => s.tid === (this.props.standortSelected || {}).tid);
        if (!this.props.data || !standort) {
            return <div>Lade ...</div>;
        }
        if (!this.lastAdressString && Object.keys(standort).length) {
            const plz: string = standort.plz || null;
            if (plz && +plz > 0) {
                this.lastAdressString = plz;
            }
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_STANDORT}
                module={IDs.MOD_ETOOL}
                directEditFormularOf={{ tid: standort.tid }}
                inlineFormular
                formAutoSave
                customClass='Custom-ETA'
                customFormConfig={this.getFormConfig()}
                onFormChange={this.onFormChange}
                onFormChangeInteractive={this.onFormChangeInteractive}
                disableFieldSelectDefaultOptions={{
                    standort_typ_tid: true,
                    energiedaten_erfassen: true
                }}
                formPreset={{ standort_typ_tid: 1 }}
                formLayout='flowV2'
                validateField={this.validateField}
                onSaveDone={() => {
                    this.triggerService.fire('reload', IDs.ENT_STANDORT, (data: any) => {
                        if (Array.isArray(data[IDs.ENT_STANDORT])) {
                            const row = data[IDs.ENT_STANDORT].find((r: any) => r.tid === standort.tid);
                            if (row.standort_typ_tid_orig === 1 || row.standort_typ_tid === 1) {
                                this.setUnternehmensdaten(row);
                            }
                        }
                    });
                }}
                refreshStamp={this.state.refreshStamp}
                bundleFilterFunc={this.state.bundleFilterFunc}
                formGroupOrder={[
                    {
                        foldable: false,
                        folded: false,
                        fields: ['name', 'gruppe', 'tochtergesellschaften', 'standort_typ_tid', 'standort_tid', 'energiedaten_erfassen', 'plz', 'ort']
                    },
                    {
                        title: 'Optionale Daten',
                        titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                        foldable: true,
                        folded: true,
                        fields: ['strasse', 'hausnummer', 'datum_von', 'datum_bis', 'ort_gtz', 'foto']
                    }
                ]}
                customCssStyle={{
                    formcontainer: { paddingLeft: 12 }
                }}
            />
        );
    }

    getFormConfig() {
        const standort: any = (this.props.data[IDs.ENT_STANDORT] || []).find((s: any) => s.tid === (this.props.standortSelected || {}).tid);
        const customFormConfig = getCustomFormConfig(IDs.ENT_STANDORT, standort || {}, this.props.data) || {};
        customFormConfig.gruppe = this.showGruppen ? {} : { hidden: true };
        // WKETOOL-139: Folien 21
        const modulSelected: string = (this.props.data || {}).MODUL_SELECTED;
        if (modulSelected === 'cfm') {
            customFormConfig.tochtergesellschaften = {
                ...(customFormConfig.tochtergesellschaften || {}),
                custom_component: this.getTochtergesellschaftenBtn,
                event_handler: this.getFormEventHandler()
            }
        }
        // console.log(customFormConfig);
        return customFormConfig;
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate?: boolean) => void): string {
        // Hauptsitz
        if (key === 'standort_typ_tid') {
            if (+value === 1) {
                const uValues = this.getUnternehmensdaten();
                Object.keys(uValues).forEach((k: string) => {
                    const sVal = data.getValue(k);
                    if (uValues[k] && !sVal) {
                        onValueChange(k, uValues[k], false);
                    }
                });
            }
        }
        return validateFieldUniversal(IDs.ENT_STANDORT, key, value, data, onValueChange, this.props.data);
    }

    getUnternehmensdaten() {
        const { data } = this.props;
        let values: any = {};
        if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0) {
            const unt = data[IDs.ENT_UNTERNEHMENSDATEN][0];
            values = {
                strasse: unt.strasse,
                hausnummer: unt.hausnummer,
                ort: unt.ort,
                plz: unt.plz
            };
        }
        return values;
    }

    setUnternehmensdaten(hauptsitz: any): void {
        const { data } = this.props;
        const unt: any = (data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
        let values: any = {};
        values.tid = +unt.tid || null;
        if (values.tid) {
            let changeCnt = 0;
            ['strasse', 'hausnummer', 'ort', 'plz', 'ort_gtz'].forEach((k: string) => {
                if ((unt[k] || '') !== (hauptsitz[k] || '')) {
                    values[k] = hauptsitz[k];
                    changeCnt++;
                }
            });
            if (changeCnt > 0) {
                this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_UNTERNEHMENSDATEN, values, (res: any) => {
                    this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN);
                });
            }
        }
    }

    getTochtergesellschaftenBtn() {
        const standort: any = (this.props.data[IDs.ENT_STANDORT] || []).find((s: any) => s.tid === (this.props.standortSelected || {}).tid);
        if (!standort) {
            return;
        }
        const tochtergesellschaftenTid = parseInt(standort.tochtergesellschaften_orig || standort.tochtergesellschaften) || 0;
        let btnStyle: any = { marginLeft: 5, marginRight: 0 };
        const directDialog = this.state.showDialog === 'addTochtergesellschaft';
        const reloadFunc = () => {
            this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN, () => {
                const bundleFilterFunc = (bundle: any) => {
                    bundle.tochtergesellschaften = this.props.data[IDs.ENT_UNTERNEHMENSDATEN_TOCHTERGESELLSCHAFTEN];
                    return bundle;
                };
                this.setState({ bundleFilterFunc, refreshStamp: this.state.refreshStamp + 1 });
            });
        };
        return <FormBtnTochtergesellschaften
            data={this.props.data}
            tochterTid={directDialog ? 0 : tochtergesellschaftenTid}
            btnStyle={btnStyle}
            directDialog={directDialog}
            onDelDone={reloadFunc}
            onSaveDone={reloadFunc}
            onClose={() => this.setState({ showDialog: null })}
        />;
    }

    getFormEventHandler() {
        return {
            onMenuOpen: (params?: any) => {
                const bundle = (params || {}).bundleData;
                if (Array.isArray(bundle) && bundle.length === 0) {
                    setTimeout(() => this.setState({ showDialog: 'addTochtergesellschaft' }), 100);
                }
            }
        };
    }
}
